import { useEffect, useState } from 'react';

const PUBLIC_VAPID_KEY = "BPvV1JKzkuR0sQ8S7TDfBFOVRbnKpStVUpFutaVEhwcSzyFqaW7Bc0nDQ3py9YwwfN-MvMAX5xIVroPOOAZsiLY";

// Convert base64 public key to Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export const usePushNotification = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState(null);

  const subscribeToPush = async () => {
    try {
      // Check if service workers and push notifications are supported
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('Push notifications are not supported in this browser');
        return;
      }

      // Get userId from localStorage
      const userId = localStorage.getItem("app_branch_id");
      if (!userId) {
        console.warn('No USER_ID found in localStorage');
        return;
      }

      // Register service worker
      const registration = await navigator.serviceWorker.register('/sw.js');
      await registration.update();

      // Request notification permission
      if (Notification.permission !== 'granted') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.warn('Push notification permission denied');
          setError('Permission denied');
          return;
        }
      }

      // Check for existing subscription
      let subscription = await registration.pushManager.getSubscription();
      
      if (!subscription) {
        // Create new subscription
        const applicationServerKey = urlBase64ToUint8Array(PUBLIC_VAPID_KEY);
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: applicationServerKey
        });
        // console.log('New push subscription created');
      } else {
        console.log('Existing push subscription found');
      }

      // Send subscription to backend
      await sendSubscriptionToBackend(userId, subscription);
      setIsSubscribed(true);

    } catch (err) {
      console.error('Error subscribing to push notifications:', err);
      setError(err.message);
      
      // Try to unregister and cleanup on error
      try {
        const registration = await navigator.serviceWorker.getRegistration('/sw.js');
        if (registration) {
          await registration.unregister();
          // console.log('Service worker unregistered after error');
        }
      } catch (unregErr) {
        console.error('Error unregistering service worker:', unregErr);
      }
    }
  };

  const sendSubscriptionToBackend = async (userId, subscription) => {
    const body = {
      ClientId: userId,
      Endpoint: subscription.endpoint,
      P256DH: subscription.getKey('p256dh') 
        ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))) 
        : '',
      Auth: subscription.getKey('auth') 
        ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))) 
        : ''
    };

    const response = await fetch('https://ordering.eatx.pk/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    // console.log("Subscription sent to backend, response status:", response);

    if (!response.ok) {
      throw new Error('Failed to send subscription to backend');
    }

    // console.log('Subscription sent to backend successfully');
  };

  useEffect(() => {
    // Auto-subscribe on mount
    subscribeToPush();
  }, []);

  return { isSubscribed, error, subscribeToPush };
};